export class VendorInputModel{
  title: string = '';
  vendorId: number = -1;
}
